import { TranslateService } from '@ngx-translate/core';

import { Tag, TagsSelectGroup } from '../models';

export const mapTagsToSelectGroups = (tags: Tag[], translate: TranslateService): TagsSelectGroup[] => {
    if (!tags || tags.length === 0) {
        return [];
    }

    const tagsByType = tags.reduce((acc: {}, item: Tag) => {
        if (!acc[item.type]) {
            acc[item.type] = [];
        }

        acc[item.type].push(item);

        return acc;
    }, {});

    const skillsSelectGroups: TagsSelectGroup[] = [];

    for (const type in tagsByType) {
        if (tagsByType[type]) {
            skillsSelectGroups.push({
                options: tagsByType[type],
                title: translate.instant(`SHARED.TAGS_SELECT.GROUP.${type.toUpperCase()}`),
            });
        }
    }

    return skillsSelectGroups;
};
